<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-23 11:28:45
 * @Description: 
 * @FilePath: /weryai-web/components/ui/ImageUploadSingle.vue
-->
<template>
    <div class="mt-4">
        <div class="flex items-center justify-between mb-3 gap-2">
            <label v-if="show_label" class="text-white text-sm font-semibold">
                {{ props.label || t('tools.imageLabel') }}
            </label>
        </div>
        <div class="w-full flex gap-2">
            <input
                ref="singleFileInput"
                type="file"
                accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
                @change="handleSingleFileSelect"
                class="hidden"
            />
            <div
                v-if="!image_url && !singleUploading"
                @click="triggerSingleFileUpload"
                @dragover.prevent
                @drop.prevent="handleSingleFileDrop"
                class="h-[127px] w-full max-h-[130px] group text-sub-title hover:text-white flex flex-col items-center justify-center rounded-[12px] border border-dashed border-white/20 p-[10px] text-center cursor-pointer"
                :class="show_type === 'prompt_reversal' ? 'bg-[#16161a]' : 'bg-black/30'"
            >
                <ui-upload-icon :hoverable="true" />

                <p
                    class="text-sub-title mt-[10px] text-sm group-hover:text-white whitespace-nowrap overflow-hidden text-ellipsis max-w-full px-2"
                >
                    {{ t('tools.imageUploadSingle') }}
                </p>
                <p class="text-sub-title text-sm group-hover:text-white">
                    {{ t('common.supportTypes') }}
                </p>
            </div>
            <div
                v-else-if="singleUploading"
                class="h-[127px] w-full max-h-[130px] flex flex-col items-center justify-center bg-black/30 rounded-[10px] p-[10px] text-center cursor-pointer"
            >
                <l-dot-spinner
                    v-if="isClient"
                    size="40"
                    speed="0.9"
                    color="var(--el-menu-active-color)"
                ></l-dot-spinner>
            </div>
            <div
                v-else-if="image_url"
                class="flex flex-col relative h-[127px] w-full max-h-[130px] items-center justify-center bg-black/30 rounded-[10px] p-[10px] text-center cursor-pointer border border-dashed border-white/20 hover:border-white/30"
            >
                <div
                    class="relative flex items-center justify-center reverse-img max-w-full max-h-full rounded-lg cursor-pointer"
                >
                    <img
                        :src="image_url"
                        alt="Loaded failed"
                        class="max-w-full max-h-full rounded-lg cursor-pointer"
                        @click="emitOpenImagePreview(image_url)"
                    />
                    <button
                        class="absolute hidden reload bg-black/70 rounded-[4px] py-1 px-2 items-center justify-center gap-[4px] text-[11px] text-white hover:text-text-active transition-all duration-300"
                        @click="handleReuploadImage"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            fill="none"
                        >
                            <g clip-path="url(#clip0_5571_8337)">
                                <path
                                    d="M10.3117 10.9313H0.686719C0.411719 10.9313 0.136719 10.6563 0.136719 10.3813V8.5251C0.136719 8.2501 0.411719 7.9751 0.686719 7.9751C0.961719 7.9751 1.23672 8.2501 1.23672 8.5251V9.83135H9.76172V8.5251C9.76172 8.2501 10.0367 7.9751 10.3117 7.9751C10.5867 7.9751 10.8617 8.2501 10.8617 8.5251V10.3813C10.8617 10.6563 10.6555 10.9313 10.3117 10.9313Z"
                                    fill="currentColor"
                                />
                                <path
                                    d="M5.49922 8.66221C5.22422 8.66221 4.94922 8.38721 4.94922 8.11221V0.687207C4.94922 0.412207 5.22422 0.137207 5.49922 0.137207C5.77422 0.137207 6.04922 0.412207 6.04922 0.687207V8.11221C6.04922 8.45596 5.84297 8.66221 5.49922 8.66221Z"
                                    fill="currentColor"
                                />
                                <path
                                    d="M8.86953 4.60615C8.73203 4.60615 8.59453 4.5374 8.45703 4.46865L5.08828 1.0999C4.88203 0.893652 4.88203 0.549902 5.08828 0.343652C5.29453 0.137402 5.63828 0.137402 5.84453 0.343652L9.21328 3.7124C9.41953 3.91865 9.41953 4.2624 9.21328 4.46865C9.14453 4.5374 9.00703 4.60615 8.86953 4.60615Z"
                                    fill="currentColor"
                                />
                                <path
                                    d="M2.2 4.60615C2.0625 4.60615 1.85625 4.5374 1.7875 4.46865C1.58125 4.2624 1.58125 3.91865 1.7875 3.7124L5.15625 0.343652C5.3625 0.137402 5.70625 0.137402 5.9125 0.343652C6.11875 0.549902 6.11875 0.893652 5.9125 1.0999L2.54375 4.46865C2.475 4.5374 2.3375 4.60615 2.2 4.60615Z"
                                    fill="currentColor"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_5571_8337">
                                    <rect
                                        width="11"
                                        height="11"
                                        fill="currentColor"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                        <span class="whitespace-nowrap">{{
                            t('common.reupload')
                        }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div
            v-if="isShowInfo"
            class="text-sub-title text-xs flex gap-1 ml-1 items-center mt-1"
        >
            <el-icon class="!text-sm"><Warning /></el-icon>
            {{ props.tip || t('upload.errors.fileTooLarge', { maxSize: 10 }) }}
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed, ref, onMounted } from 'vue'
import { Warning } from '@element-plus/icons-vue'
import { useI18n } from '@/composables/useI18n'
import { debounce, noticeMessagePopup, getMaxImageSize } from '@/utils/common'
import { emitOpenImagePreview, showLoginModal } from '~/utils/emitter'
import axios from 'axios'
import { useUserStore } from '~/stores/user'

const userStore = useUserStore()
const isLoggedIn = computed(() => userStore.isLoggedIn)
const { t, locale } = useI18n()

// 支持自定义标题
const props = withDefaults(
    defineProps<{
        label?: string
        isShowInfo?: boolean
        tip?: string
        show_label?: boolean,
        show_type?: string
    }>(),
    {
        label: '',
        isShowInfo: true,
        tip: '',
        show_label: true,
    }
)

const frame_end_mode = defineModel('frame_end_mode', {
    type: Boolean,
    default: false,
})
const image_url = defineModel('image_url', {
    type: String,
    default: '',
})

const image_size = defineModel('image_size', {
    type: Number,
    default: 0,
})

const singleFileInput = ref<HTMLInputElement | null>(null)

const triggerSingleFileUpload = () => {
    if (!isLoggedIn.value) {
        showLoginModal()
        return
    }
    singleFileInput.value?.click()
}

const handleSingleFileDrop = (event: DragEvent) => {
    if (!isLoggedIn.value) {
        showLoginModal()
        return
    }
    const files = event.dataTransfer?.files
    if (files) {
        const fileArray = Array.from(files)
        handleSingleAutoBatchUpload(fileArray)
    }
}

const uploadSingleFileList = ref<File[]>([])
const singleUploading = ref(false)

// 仅允许：jpg / jpeg / png / webp
const ALLOWED_IMAGE_MIME = new Set(['image/jpeg', 'image/png', 'image/webp'])
const ALLOWED_IMAGE_EXT = new Set(['jpg', 'jpeg', 'png', 'webp'])

const isAllowedImageFile = (file: File) => {
    const fileName = (file?.name || '').toLowerCase()
    const ext = fileName.includes('.') ? fileName.split('.').pop() || '' : ''
    const byExt = !!ext && ALLOWED_IMAGE_EXT.has(ext)
    const byMime = !!file?.type && ALLOWED_IMAGE_MIME.has(file.type)
    // 有些浏览器/场景拖拽时 type 可能为空，所以两者任一满足即可
    return byExt || byMime
}

const resetSingleInputValue = () => {
    if (singleFileInput.value) {
        singleFileInput.value.value = ''
    }
}

const notifyUnsupportedImageFormat = () => {
    noticeMessagePopup(
        t('tools.errorUnsupportedImageFormat'),
        t('common.tip'),
        'error',
        3000,
        ''
    )
}

// single file upload
const handleSingleFileSelect = (event: Event) => {
    const target = event.target as HTMLInputElement | null
    const files = target?.files
    if (!files || files.length === 0) return

    const fileArray = Array.from(files)
    // 允许用户重复选择同一张图片时也能触发 change
    if (target) target.value = ''
    handleSingleAutoBatchUpload(fileArray)
}
// @ts-ignore
const config = useRuntimeConfig()
let token = ''
let language = 'en'

// upload image
const handleSingleAutoBatchUpload = debounce(async (fileList: File[]) => {
    if (!fileList?.length) return

    // 校验文件类型（仅允许 jpg/png/webp）
    for (const file of fileList) {
        if (!isAllowedImageFile(file)) {
            notifyUnsupportedImageFormat()
            resetSingleInputValue()
            return
        }
    }

    // 校验文件大小（限制为10MB）
    for (const file of fileList) {
        if (!getMaxImageSize(file, 10)) {
            // 文件大小超过限制，显示错误提示
            noticeMessagePopup(
                t('upload.errors.fileTooLarge', { maxSize: 10 }),
                t('common.tip'),
                'error',
                3000,
                ''
            )
            // 重置 input 值，允许再次选择相同文件
            resetSingleInputValue()
            return
        }
    }

    uploadSingleFileList.value = fileList

    // set skeleton screen number
    const formData = new FormData()
    uploadSingleFileList.value.forEach((fileObj: File) => {
        formData.append('files', fileObj)
    })
    singleUploading.value = true
    try {
        // @ts-ignore
        if (import.meta.client) {
            token = localStorage.getItem('token') || ''
            // 请求语言跟随当前 URL 的 locale，而不是偏好/旧的 localStorage('language')
            language = locale.value || 'en'
        }
        const url = new URL(
            config.public.apiBase + '/api/v1/auth/s3/upload_images'
        )
        url.searchParams.append('app_key', config.public.appKey)

        const res = await axios.post(url.toString(), formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: token,
                'Accept-Language': language,
            },
        })
        const { data, status } = res.data
        if (status === 200) {
            image_url.value = data?.object_url_list?.[0]
            // image_size：文件大小（单位 KB）
            // File.size 是字节(byte)，换算成 KB = bytes / 1024
            const firstFile = uploadSingleFileList.value?.[0]
            if (firstFile && typeof firstFile.size === 'number') {
                // 用整数 KB（向上取整），便于展示/传参
                image_size.value = Math.ceil(firstFile.size / 1024) || 0
            } else {
                image_size.value = 0
            }
            singleUploading.value = false
        } else if ([1005, 4001, 4002].includes(status)) {
            showLoginModal()
        }
    } catch (err) {
        console.error('upload failed:', err)
    } finally {
        singleUploading.value = false
    }
}, 500)

const onImageError = () => {
    noticeMessagePopup(
        t('tools.imageLoadFailed'),
        t('common.tip'),
        'warning',
        3000,
        ''
    )
    image_url.value = ''
    image_size.value = 0
}

const clearEditImage = () => {
    image_url.value = ''
    image_size.value = 0
}

const handleReuploadImage = () => {
    // 重新上传本质上是“再打开一次文件选择框”，不应该伪造 change 事件
    // 同时重置 input，确保选择同一文件也能再次触发 change
    if (!isLoggedIn.value) {
        showLoginModal()
        return
    }

    resetSingleInputValue()
    image_url.value = ''
    image_size.value = 0
    singleFileInput.value?.click()
}

const isClient = ref(false)

// 只在客户端注册 ldrs
onMounted(async () => {
    if (typeof window !== 'undefined') {
        try {
            const { dotSpinner } = await import('ldrs')
            dotSpinner.register()
            // 确保注册完成后再设置 isClient，避免组件在注册前渲染
            isClient.value = true
        } catch (error) {
            console.error('Failed to load ldrs:', error)
            // 即使加载失败也设置为 true，避免无限等待
            isClient.value = true
        }
    }
})
</script>
<style scoped lang="less">
.reverse-img:hover .reload {
    display: flex !important;
    color: var(--el-menu-active-color);
}
</style>
